import { initProsSlider } from './pro-custom-installer-pros/pro-custom-installer-pros';
import YTPlayer from '../../scripts/components/YTPlayer';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';

initProsSlider();
YTPlayer.init();
initInstallationSlider();
